import { z } from "zod";

export const AwLaboratoryIdSchema = z.object({
	aw_laboratory_id: z.string()
});

export type AwLaboratoryId = z.infer<typeof AwLaboratoryIdSchema>;
